import PropTypes from 'prop-types'

import placeholderFactory from './factory'

export default placeholderFactory('AcpEnum', {
  slug: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  color: PropTypes.string,
})
